// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: ShowInventoryToggleStyles;
}

export interface ShowInventoryToggleStyles {
    toggleClickable?: ClickablePresentationProps;
    toggleIcon?: IconPresentationProps;
    toggleTypography?: TypographyPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    checkbox?: CheckboxProps;
}

export const showInventoryToggleStyles: ShowInventoryToggleStyles = {
    checkbox: {
        variant: "toggle",
        labelPosition: "right",
        sizeVariant: "small",
    },
};

export const ShowInventoryToggle = ({ extendedStyles }: OwnProps) => {
    const dispatch = useAppDispatch();
    const showInventory = useAppSelector(state => state.context.showInventory);
    const styles = useMergeStyles("showInventoryToggleStyles", showInventoryToggleStyles, extendedStyles);

    const clickShowInventoryToggleHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        dispatch(setShowInventory({ showInventory: !showInventory }));
    };

    return (
        <StyledWrapper {...styles.wrapper} className="show-inventory-toggle" /* Starter Custom Code */>
            {/* Starter Custom Code - Start */}
            <Checkbox
                {...styles.checkbox}
                checked={showInventory}
                onChange={clickShowInventoryToggleHandler}
                data-test-selector={showInventory ? "NotShowInventory" : "ShowInventory"}
            >
                {translate("Show Inventory")}
            </Checkbox>
            {/* Starter Custom Code - End */}
        </StyledWrapper>
    );
};

export default ShowInventoryToggle;
